module.exports = __webpack_public_path__ + "static/media/10.55feef4d.jpg";